
export const PATIENT_DETAILS = 'PATIENT_DETAILS';
export const PATIENT_DETAILS_SUCCESS = 'PATIENT_DETAILS_SUCCESS';
export const PATIENT_DETAILS_ERROR = 'PATIENT_DETAILS_ERROR';

export const FAMILY_TREE = 'FAMILY_TREE';
export const FAMILY_TREE_SUCCESS = 'FAMILY_TREE_SUCCESS';
export const FAMILY_TREE_ERROR = 'FAMILY_TREE_ERROR';

export const PROFILE_FAMILY_GET = 'PROFILE_FAMILY_GET';

export const GET_COUNTRIES = 'GET_COUNTRIES';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

export const ADD_NEW_FAMILY = 'ADD_NEW_FAMILY';
export const ADD_NEW_FAMILY_SUCCESS = 'ADD_NEW_FAMILY_SUCCESS';
export const ADD_NEW_FAMILY_ERROR = 'ADD_NEW_FAMILY_ERROR';


export const DELETE_FAMILY_MEMBER = 'DELETE_FAMILY_MEMBER';
export const DELETE_FAMILY_MEMBER_SUCCESS = 'DELETE_FAMILY_MEMBER_SUCCESS';
export const DELETE_FAMILY_MEMBER_ERROR = 'DELETE_FAMILY_MEMBER_ERROR';

export const UPDATE_FAMILY_MEMBER = 'UPDATE_FAMILY_MEMBER';
export const UPDATE_FAMILY_MEMBER_SUCCESS = 'UPDATE_FAMILY_MEMBER_SUCCESS';
export const UPDATE_FAMILY_MEMBER_ERROR = 'UPDATE_FAMILY_MEMBER_ERROR';